<app-action-button-with-embedded-spinner [actionObservable]="updateZCStatus.bind(this)" [icon]="'replay'"
    [hint]="'Update Zoning Code status and statistic'"></app-action-button-with-embedded-spinner>